import { useContext, useEffect, useRef, useState } from "react";
import ViewportContext from "../../../../context/studyviewer/ViewportContext";
import Crop from "../../../../components/SVGComponents/Tools/Crop";
import { annotation, Enums } from "@cornerstonejs/tools";
import toolStyle from "@cornerstonejs/tools/annotation/config/ToolStyle";
import { eventTarget } from "@cornerstonejs/core";
import ThumbnailContext from "../../../../context/studyviewer/ThumbnailContext";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import themeContext from "../../../../context/theme/ThemeContext";
import { t } from "i18next";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import { getViewport } from "../../../StudyViewer/helpers/CornerstoneViewportService";
const csToolsEvents = Enums.Events;


const MaskButton = ({ imageId }) => {

  const { setActiveTool, activeTool, disableMasking,
    setPreviousActiveTool, isCropEnable, setIsCropEnable, maskingConfirm, setMaskingConfirm } = useContext(ViewportContext);

  const { maskImages, setMaskImages } = useContext(studyviewerContext);
  const { theme } = useContext(themeContext);
  const maskImagesRef = useRef(maskImages);

  const imageIdRef = useRef(imageId);
  console.log("ImageId", imageId)

  useEffect(() => {
    console.log("maskImages", imageId);
    imageIdRef.current = imageId;
  }, [imageId])

  useEffect(() => {
    console.log("maskImages", maskImages);
    maskImagesRef.current = maskImages;
  }, [maskImages])

  useEffect(() => {
    disableMasking();
  }, [imageId])

  const cropEnabledRef = useRef(isCropEnable);

  useEffect(() => {
    cropEnabledRef.current = isCropEnable;

  }, [isCropEnable]);

  function getUpdatedMaskImages(prevImages,id, annotation) {
    console.log(prevImages);
    const existingImage = prevImages[id] || { maskAnnotationData: [] };
    const existingAnnotations = existingImage.maskAnnotationData || [];
    const index = existingAnnotations.findIndex(
      a => a.annotationUID === annotation.annotationUID
    );

    const updatedAnnotations =
      index === -1
        ? [...existingAnnotations, annotation] // add
        : existingAnnotations.map((a, i) => (i === index ? annotation : a));
    return {
      ...prevImages,
      [id]: {
        ...existingImage,
        maskAnnotationData: updatedAnnotations,
      },
    };
  }


  const onAnnotationCompleted =  (evt) => {
    // if (!cropEnabledRef.current)
    //   return;

    const updated = getUpdatedMaskImages(maskImagesRef.current, imageIdRef.current,evt.detail.annotation);
    console.log("oncomplete", updated);
    setMaskImages(updated);


  };

  const onAnnotationAdded = (evt) => {
    // if (!cropEnabledRef.current)
    //   return;
    toolStyle.setAnnotationStyles(evt.detail.annotation.annotationUID, {
      lineWidth: "1px",
      textBoxLinkLineWidth: "0",
      textBoxFontSize: "0px",
      colorSelected: "#ffffff",
      colorHighlighted: "#ffffff",
      lineDash: [5, 5]
    });
  }

  function updateMaskImagesWithModifiedAnnotation(prev, id, modifiedAnnotation) {
     const existingImage = prev[id] || { maskAnnotationData: [] };

    const existingAnnotations = existingImage.maskAnnotationData || [];
    const index = existingAnnotations.findIndex(
      a => a.annotationUID === modifiedAnnotation.annotationUID
    );

     const updatedAnnotations =
    index === -1
      ? [...existingAnnotations, modifiedAnnotation] // If not found, add
      : existingAnnotations.map((a, i) => (i === index ? modifiedAnnotation : a)); // Else, update

    return {
      ...prev,
      [id]: {
        ...existingImage,
        maskAnnotationData: updatedAnnotations
      },
    };
  }


  const onAnnotationModified =  (evt) => {
    // if (!cropEnabledRef.current)
    //   return;
    const modifiedAnnotation = evt.detail.annotation;

    const updated = updateMaskImagesWithModifiedAnnotation(maskImagesRef.current, imageIdRef.current, modifiedAnnotation);
    console.log(updated);
    setMaskImages(updated);
  };


  useEffect(() => {
  if (!isCropEnable) return;
  eventTarget.addEventListener(csToolsEvents.ANNOTATION_COMPLETED, onAnnotationCompleted);
    eventTarget.addEventListener(csToolsEvents.ANNOTATION_MODIFIED, onAnnotationModified);
    eventTarget.addEventListener(csToolsEvents.ANNOTATION_ADDED, onAnnotationAdded);

    return () => {
      eventTarget.removeEventListener(csToolsEvents.ANNOTATION_MODIFIED, onAnnotationModified);
      eventTarget.removeEventListener(csToolsEvents.ANNOTATION_ADDED, onAnnotationAdded);
      eventTarget.removeEventListener(csToolsEvents.ANNOTATION_COMPLETED, onAnnotationCompleted);
    };
  }, [isCropEnable]);



  const onCropImage = (e) => {

    if (isCropEnable) { //Executes when mask mode is ON and user wants to turns it OFF
      disableMasking();
      return;
    }

    setMaskingConfirm(() => {
      let newVal = { ...maskingConfirm };
      newVal.show = true;
      newVal.success = true;
      newVal.name = "";
      newVal.color = "#0078d4";
      return newVal;
    });


    setPreviousActiveTool(activeTool);
    setActiveTool("RectangleROI");
    cropEnabledRef.current = true;

    setIsCropEnable(true);

  }

  return (
    <CustomToolTipHost
      // toolTipProps={toolTipProps}
      content={
        isCropEnable
          ? t("heading.stop-mask")
          : t("heading.start-mask")}
      id="MaskImage"
      tooltipProps={{
        calloutProps: {
          styles: {
            beak: { background: "#252525;" },
            beakCurtain: { background: "#252525;" },
            calloutMain: { background: "#252525;" },
            borderRadius: "20%",
          },
        },
      }}
    >

      <div className="highlight-tool" onClick={() => { onCropImage() }} style={{ cursor: 'pointer' }}>
        <Crop color={isCropEnable ? theme.palette.activeTool : '#bfbfbf'} />
      </div>
    </CustomToolTipHost>
  );
}

export default MaskButton;